import React from "react";
import { FormContainerItem, TextField } from "@graffer-inc/console-design-kit";

interface BasicInfoProps {
  rulesetName: string;
  setRulesetName: (value: string) => void;
  description: string;
  setDescription: (value: string) => void;
  nameErrorMessages?: string[];
  descriptionErrorMessages?: string[];
}

export const RulesetBasicInfo: React.FC<BasicInfoProps> = ({
  rulesetName,
  setRulesetName,
  description,
  setDescription,
  nameErrorMessages = [],
  descriptionErrorMessages = [],
}) => (
  <>
    <FormContainerItem>
      <TextField
        label="名前"
        description={"申請振り分け設定の名前を入力して下さい"}
        placeholder={"（例）部署選択項目"}
        required
        value={rulesetName}
        onChange={(e) => setRulesetName(e.target.value)}
        errorMessages={nameErrorMessages}
      />
    </FormContainerItem>
    <FormContainerItem>
      <TextField
        label="説明"
        description={"申請振り分け設定の説明を入力して下さい"}
        placeholder={"（例）部署振り分けを定義する申請振り分け設定"}
        required
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        errorMessages={descriptionErrorMessages}
      />
    </FormContainerItem>
  </>
);
